import React, { useState, useEffect, useRef } from 'react';
import '../assets/styles/global.scss';
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(window.scrollY); // ✅ useRef instead of useState

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY < 100) {
      setIsSticky(false);
      setIsVisible(true);
    } else {
      if (currentScrollY > lastScrollY.current) {
        setIsVisible(false); // scrolling down
      } else {
        setIsSticky(true);
        setIsVisible(true); // scrolling up
      }
    }

    lastScrollY.current = currentScrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); // ✅ only once

  const headerClass = `${isSticky ? 'sticky-header' : ''} ${isVisible ? 'show' : 'hide'}`;

  return (
    <header className={headerClass}>
      <div className='mobile-menu-button' onClick={toggleDrawer}>
        <FontAwesomeIcon icon={isDrawerOpen ? faTimes : faBars} size="1x" />
      </div>

      <div className='links'>
        <NavLink className="link" to="/contact">تماس با ما</NavLink>
        <NavLink className="link" to="/about">درباره ما</NavLink>
        <NavLink className="link" to="/blog">اخبار</NavLink>
        <NavLink className="link" to="/express">وطن اکسپرس</NavLink>
        <NavLink className="link" to="/vipClient">مشتریان ویژه تجاری</NavLink>
      </div>

      <a href='/' className='logo'></a>

      <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
        <div className='mobile-menu-close' onClick={toggleDrawer}>
          <FontAwesomeIcon icon={faTimes} size="1x" />
        </div>
        <a href='/' className='logo-mobile'></a>
        <NavLink className="link" to="/" onClick={toggleDrawer}>خانه</NavLink>
        <NavLink className="link" to="/vipClient" onClick={toggleDrawer}>مشتریان ویژه تجاری</NavLink>
        <NavLink className="link" to="/express" onClick={toggleDrawer}>وطن اکسپرس</NavLink>
        <NavLink className="link" to="/blog" onClick={toggleDrawer}>اخبار</NavLink>
        <NavLink className="link" to="/contact" onClick={toggleDrawer}>تماس با ما</NavLink>
        <NavLink className="link" to="/about" onClick={toggleDrawer}>درباره ما</NavLink>
      </div>

      <div className={`drawer-overlay ${isDrawerOpen ? 'open' : ''}`} onClick={toggleDrawer}></div>
    </header>
  );
}

export default Header;
